import React from "react";
import { useAuth } from "../../../../providers/AuthProvider";
import { useSubject } from "../../providers/SubjectProvider";
import NutritionPlanTab from "./NutritionPlanTab";
import NutritionPlanProvider from "./nutritionPlan/store/NutritionPlanProvider";
import NutritionPlanView from "./nutritionPlan/NutritionPlanView";

/**
 * Programming → Nutrition. A subject with an active meal plan gets the plan
 * (ported from the mobile Nutrition tab); everyone else keeps the report-based
 * summary in `NutritionPlanTab`. `subject` is the customer themself on
 * `/platform` and the selected client on `/client`, both carrying
 * `has_active_plan` from the NUT settings call.
 *
 * The provider is keyed by subject so switching client drops its caches.
 */
const NutritionProgrammingTab = () => {
  const { subject, subjectId } = useSubject();
  const { AuthUser } = useAuth();

  if (subject?.has_active_plan === true && subjectId) {
    return (
      <NutritionPlanProvider
        key={subjectId}
        subjectId={subjectId}
        role={AuthUser.role}
        canEdit={false}
      >
        <NutritionPlanView />
      </NutritionPlanProvider>
    );
  }

  return <NutritionPlanTab />;
};

export default NutritionProgrammingTab;
